import(/* webpackMode: "eager" */ "/app/src/app/[locale]/contacts/layout.tsx");
